import { InlineText3 } from '@cian/ui-kit';
import { RadioButtonGroup } from '@cian/ui-kit/radio';
import * as React from 'react';
import { IFormattedPeriod } from '../../../../redux/reducers';
import * as styles from './PlacingPeriod.desktop.css';

interface IPlacingPeriodDesktopProps {
  activePeriodId: string | null;
  periods: IFormattedPeriod[];
  hint: string | null;
  onChangePeriod(newPeriodId: string): void;
}

export const PlacingPeriodDesktop = ({ activePeriodId, periods, hint, onChangePeriod }: IPlacingPeriodDesktopProps) => {
  const handleChangePeriod = React.useCallback(
    (e, newPeriodId: string) => {
      onChangePeriod(newPeriodId);
    },
    [onChangePeriod],
  );

  return (
    <div className={styles['wrapper']}>
      <RadioButtonGroup
        name="placingPeriod"
        value={activePeriodId || undefined}
        options={periods}
        onChange={handleChangePeriod}
      />

      {hint && (
        <div className={styles['hint']}>
          <InlineText3 color={'gray60_100'}>{hint}</InlineText3>
        </div>
      )}
    </div>
  );
};
